// disable patching specified eventNames
(globalThis as any).__zone_symbol__UNPATCHED_EVENTS = ['mousemove', 'wheel', 'touchstart', 'touchmove', 'touchend'];
(globalThis as any).__zone_symbol__BLACK_LISTED_EVENTS = ['mousemove', 'wheel', 'touchstart', 'touchmove', 'touchend'];
